import { Brick, registerBrick } from 'olympe';

export default class StopLoadingPopup extends Brick {

    /**
     * Executed every time the brick receives a new trigger event.
     * Note that the method will be executed _even if_ an input () is undefined.
     * 
     * @protected
     * @param {BrickContext} context
     * @param {!Array} inputs
     * @param {function()} forwardEvent
     */
    onUpdate(context, inputs, [forwardEvent]) {
        document.getElementById('loadingPopup017ba68e52cfa6db8329')?.remove();
        forwardEvent();
    }
}

registerBrick('017bba1a54bf18e52479', StopLoadingPopup);
